<template>
  <div class="jr-component">
    <el-input v-bind="$attrs" :id="components.controlId" :size="size" :placeholder="placeholder" v-model="componentValue.controlDefaultvalue" :disabled="!components.controlRighttype" class="input-with-select" clearable>
      <span><slot></slot></span>
      <el-select @change="selectChange" v-model="componentValue.controlName" slot="prepend" placeholder="请选择">
        <el-option v-for="(item, i) in selectData" v-bind:key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <!-- <el-button class="input-with-append" @click="nextLikeType" slot="append" :title="likeTypeTitle[nowLikeNum]">{{ likeType[nowLikeNum] }}</el-button> -->
      <el-dropdown trigger="click" class="input-with-append" slot="append" :title="likeTypeTitle[nowLikeNum]">
        <span class="el-dropdown-link hand-pointer">
          {{ likeType[nowLikeNum] }}
        </span>
        <el-dropdown-menu slot="dropdown" >
          <div @click="nextLikeType" v-for="(like,i) in likeType" v-bind:key="like" :id="i"><el-dropdown-item >{{ likeTypeTitle[i] + '(' + like + ')' }}</el-dropdown-item></div>
        </el-dropdown-menu>
      </el-dropdown>
    </el-input>
    <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
    <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/>
  </div>
</template>
<script>
import JRGLOBAL from '@/api/jrglobal'
export default {
  name: 'JrSearchgroup',
  data() {
    return {
      likeType: JRGLOBAL.likeType,
      likeTypeTitle: JRGLOBAL.likeTypeTitle,
      nowLikeNum: 0,
    }
  },
  computed: {
    componentValue: {
      get() {
        const nowLikeNum = this.likeType.indexOf(this.value.controlLiketype)
        if(nowLikeNum > 0){
          this.nowLikeNum = nowLikeNum
        }else{
          this.nowLikeNum = 0
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    size: {
      type: String,
      default: 'small'
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    selectData: {}
    
  }    
  ,
  methods: {
    rightClick() {
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    nextLikeType(e) {      
      this.nowLikeNum = e.currentTarget.id
      this.componentValue.controlLiketype = this.likeType[this.nowLikeNum]
    },
    selectChange(e) {
      for(var key in this.selectData){
        if(this.selectData[key].id == e){
          this.componentValue.controlDisplayname = this.selectData[key].value
        }
      }
      
    }
  }
}
</script>
<style scoped lang="scss">  
  .el-select{
    width: 130px;    
  }
  .input-with-append{
    width: 20px;  
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrSearchgroup.vue